import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

interface Configuration {
  apiUrlData: {
    giftCard: string;
    contact: string;
    global: string;
    customer: string;
    smartPublicCustomer;
  };
}

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private config: Configuration;
  constructor(private httpClient: HttpClient) {}

  load(url: string) {
    return new Promise<void>((resolve) => {
      this.httpClient.get(url).subscribe(
        (config: Configuration) => {
          this.config = config;
          resolve();
        },
        (err) => {
          console.log(err);
        }
      );
    });
  }

  getConfiguration(): Configuration {
    return this.config;
  }
}
